import SaveToWorkspace from '@patsnap-biz/save-to-workspace-v2'
import { defineComponent, getCurrentInstance, onUnmounted, ref } from '@vue/composition-api'
import { workspaceComponentProps } from '../../type'
import $classes from '../Workspace.module.scss'
import SaveClinicalResultService from './SaveClinicalResultService'

const { SaveClinicalResultToWorkspace } = SaveToWorkspace
export const ClinicalResultWorkspace = defineComponent({
  name: 'ClinicalResultWorkspace',
  props: workspaceComponentProps(),
  setup(props) {
    const instance = getCurrentInstance()

    const ClinicalService = ref()

    ClinicalService.value = new SaveClinicalResultService({ vm: instance?.proxy, ...props })

    const close = () => {
      ClinicalService.value = null
    }

    onUnmounted(close)

    return {
      ClinicalService,
    }
  },
  render() {
    if (this.ClinicalService) {
      return <SaveClinicalResultToWorkspace service={this.ClinicalService} append-to-body class={$classes.workspace}></SaveClinicalResultToWorkspace>
    }
    return <span></span>
  },
})
